// ** Redux Imports
import { createSlice } from "@reduxjs/toolkit";

export const layoutStatusSlice = createSlice({
    name: "layoutStatus",
    initialState: {},
    reducers: {
        setLayoutStatus: (state, action) => {
            const { name, status } = action.payload || {};
            if (!state[name]) state[name] = {};
            state[name].status = status;
        },
        setLayoutPermissions: (state, action) => {
            const { name, permissions } = action.payload || {};
            const can_permissions = Object.fromEntries(
                Object.entries(permissions || {}).filter(([key]) => key?.startsWith('can_'))
            );
            if (!state[name]) state[name] = {};
            state[name].permissions = can_permissions;
        }
    }
});

export const { setLayoutStatus, setLayoutPermissions } = layoutStatusSlice.actions;

export default layoutStatusSlice.reducer;

